<template>
    <div>
      <div class="white-section">
        <b-form @submit.prevent class="mt-0">
        <b-row>
            <b-col md="4">
            <label style="margin-bottom:20px !important" for="selected-date">تاریخ</label>
            <my-ab-date-picker
                  :ref="selectedDate ? selectedDate.toString() : 'selected-date'"
                  :type="'date'"
                  :locale="'fa,en'"
                  click-on="all"
                  :clearable="false"
                  :show="false"
                  :auto-submit="true"
                  :column="1"
                  v-model="selectedDate"
                  :toIso="true"
                  :custom-hour="23"
                  id="selected-date"
                  >
                </my-ab-date-picker>
          </b-col>
          <b-col md="4">
            <b-form-group :label="$t('holiday.descriptionCalendar')" label-for="holiday-desc" >
                <textarea
                    name=""
                    v-model="descriptionCalendar"
                    id="holiday-desc"
                    class="form-control"
                    style="min-height: 100px"
                ></textarea>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group :label="$t('holiday.descriptionCenter')" label-for="holiday-description" >
                <textarea
                    name=""
                    v-model="description"
                    id="holiday-description"
                    class="form-control"
                    style="min-height: 100px"
                ></textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-end">
            <b-button
            size=""
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="info"
            @click="addHoliday"
        >
            {{ $t("general.submit") }}
        </b-button>
        </div>
        </b-form>
      </div>
    </div>
</template>
  
  <script>
  import Ripple from "vue-ripple-directive";
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import MyAbDatePicker from "@/components/wrapper/datePicker/MyAbDatePicker.vue";
  import moment from "jalali-moment";
  import {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
    BFormInvalidFeedback,
    BBreadcrumb,
  } from "bootstrap-vue";
  
  export default {
  
    data() {
      return {
        selectedDate:"",
        description:"",
        descriptionCalendar:""
      }
    },
    created() {
      this.pushBreadcrumb({text: 'addHoliday', to:{name:'addHoliday' }, translate:true})
      this.setCurrentBreadcrumb([{text: 'addHoliday', to:{name:'addHoliday' }, translate:true}])
    },
    directives: {
      Ripple,
    },
    components: {
      BRow,
      BCol,
      BFormGroup,
      BFormInput,
      BFormCheckbox,
      BForm,
      BButton,
      BFormSelect,
      BFormInvalidFeedback,
      BBreadcrumb,
      MyAbDatePicker,
      moment,
      ToastificationContent
    },
    validations() {
      return {

      };
    },
    computed: {
  
    },
    methods: {
      addHoliday() {
        this.$v.$touch();
  
            if(this.selectedDate !== ""){
              const payload = {
              date: moment(this.selectedDate).format('YYYY-MM-DD'),
              descriptionCalendar : this.descriptionCalendar,
              descriptionCenter : this.description,
              status:"active"
            };
          this.$store.commit('SET_IS_LOADING', true)
            this.$store
              .dispatch("holiday/AddHoliday", payload)
              .then((response) => {
                this.$store.commit('SET_IS_LOADING', false)
                this.$bvToast.toast(this.$t('toastification.submissionSucceed'), {
                  variant: 'success',
                  solid: true,
                });
                this.selectedDate = '';
                this.descriptionCenter = '';
                this.descriptionCalendar = '';
                this.$router.push({name: "manageHolidays"});
              })
              .catch((error) => {
              });
            }else{
              this.$bvToast.toast(this.$t('toastification.dateNotSelected'), {
                  title: this.$t('toastification.error'),
                  variant: 'danger',
                  solid: true,
                });
            }
          this.$store.commit('SET_IS_LOADING', false)
        },
    },
  };
  </script>